const { forEach } = require('lodash');

class FooterController {
    constructor($anchorScroll, settings, analyticsService, breakpoints, moveFocus) {
        this.$anchorScroll = $anchorScroll;
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.breakpoints = breakpoints;
        this.moveFocus = moveFocus;
    }

    $onInit() {
        this.footerColumns = {
            customerService: this.formatLinks(this.settings.footer.customerServiceLinks),
            service: this.formatLinks(this.settings.footer.generalServiceLinks),
            tools: this.formatLinks(this.settings.footer.toolsLinks),
            aboutUs: this.formatLinks(this.settings.footer.aboutUsLinks),
        };
    }

    formatLinks(footerLinkRaw) {
        const footerLinks = [];
        forEach(footerLinkRaw, (value) => {
            if (value.length === 1) {
                footerLinks.push({
                    heading: value[0],
                    children: [],
                });
            } else if (value.length === 2 && footerLinks.length) {
                footerLinks[footerLinks.length - 1].children.push({
                    heading: value[0],
                    link: value[1],
                });
            }
        });
        return footerLinks;
    }

    isPanelSelected(panel) {
        return this.selectedPanel === panel.heading;
    }

    togglePanel(panel) {
        if (panel.children.length) {
            this.selectedPanel = (this.selectedPanel !== panel.heading)
                ? panel.heading
                : null;
        }
    }

    expandPanel(panel) {
        this.selectedPanel = panel.heading;
    }

    centerPanelFocus() {
        this.$anchorScroll();
        this.moveFocus('#body-container');
    }

    pushToAnalytics(category, row) {
        const eventData = !category || !row ? null : {
            category: category.heading || '',
            value: row.link || '',
            label: row.heading || '',
        };

        this.analyticsService.push({
            data: {
                event: eventData,
                trackingType: 'link',
            },
            type: this.analyticsService.mapperTypes.customEvent.linkClick,
        });
    }
}

const footerControllerComponentDefinition = {
    controller: ['$anchorScroll', 'Settings', 'AnalyticsService', 'BreakpointsService', 'MoveFocus', FooterController],
    template: require('./footer.component.html').trim(),
};

module.exports = {
    FooterController,
    footerControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/common/footer/footer.component.js